import { useRef } from 'react';

const shakeClassName = 'shaking';

const useShake = () => {
  const shakeRef = useRef<HTMLLIElement>(null);

  const startShake = () => {
    if (shakeRef.current) {
      shakeRef.current?.classList?.add(shakeClassName); // Add a new class
      shakeRef.current?.classList?.add('blue-border'); // Add a new class
      setTimeout(() => {
        shakeRef.current?.classList?.remove(shakeClassName);
      }, 400); // Shake for 400ms
      setTimeout(() => {
        shakeRef.current?.classList?.remove('blue-border');
      }, 2000); // Shake for 400ms
    }
  };

  return { startShake, shakeRef };
};

export default useShake;
